export const translate = (locale: "nl" | "en", query: string) => {
  switch (query) {
    case "opinion":
      return { nl: "mening", en: "opinion" }[locale]
    case "advice":
      return { nl: "advies", en: "advice" }[locale]
    case "knowledge":
      return { nl: "kennis", en: "knowledge" }[locale]
    default:
      return query
  }
}
